import { defineComponent, onMounted, getCurrentInstance, onUpdated, onUnmounted } from "vue";
import ResizeObserver$1 from "resize-observer-polyfill";
import { findDomNode } from "../_utils/dom.js";
var ResizeObserver = defineComponent({
  name: "ResizeObserver",
  emits: [
    "resize"
  ],
  setup(props, {
    emit,
    slots
  }) {
    let resizeObserver;
    const findElement = (instance) => {
      return findDomNode(instance.vnode);
    };
    const findOldElement = (instance) => {
      return findDomNode(instance.subTree);
    };
    const createResizeObserver = (target) => {
      if (!target)
        return;
      resizeObserver = new ResizeObserver$1((entries) => {
        const entry = entries[0];
        emit("resize", entry);
      });
      resizeObserver.observe(target);
    };
    const destroyResizeObserver = () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    };
    onMounted(() => {
      const instance = getCurrentInstance();
      if (instance) {
        const element = findElement(instance);
        createResizeObserver(element);
      }
    });
    onUpdated(() => {
      const instance = getCurrentInstance();
      if (instance) {
        const element = findElement(instance);
        const oldElement = findOldElement(instance);
        if (element !== oldElement) {
          if (resizeObserver)
            destroyResizeObserver();
          createResizeObserver(element);
        }
      } else {
        destroyResizeObserver();
      }
    });
    onUnmounted(() => {
      destroyResizeObserver();
    });
    return () => {
      const children = slots.default && slots.default();
      return children && children.length ? children[0] : null;
    };
  }
});
export { ResizeObserver as default };
